import { useEffect, useState } from "react";
import { API_BASE_URL } from "../Config/Config";
import Pagination from "../Config/Pagination";

export function HomeComponent() {
  const [storedUserData, setStoredUserData] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [teamLeaves, setTeamLeaves] = useState([]);
  const [dates, setDates] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedActiveDate, setSelectedActiveDate] = useState(null);
  const [selectedCurentDate, setSelectedCurentDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const currentItems = teamLeaves.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    const userDataString =
      localStorage.getItem("userData") || sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setStoredUserData(userData);
    } else {
      console.log("User data not found");
    }
  }, []);

  // useEffect(() => {
  //   if (storedUserData?.RegId) {
  //     const fetchTeamLeaves = async () => {
  //       try {
  //         const response = await fetch(
  //           // `${API_BASE_URL}team/getmyteamleaves?regid=${storedUserData.RegId}&emplregid=&status=1&year=`
  //         );
  //         if (!response.ok) {
  //           throw new Error("Network response was not ok");
  //         }
  //         const data = await response.json();
  //         const filteredData =
  //           data?.["ResultData"]?.filter((item) => item?.status === 1) || [];
  //         setTeamLeaves(filteredData);
  //       } catch (error) {
  //         console.error("Error fetching team members:", error);
  //       }
  //     };

  //     const fetchHolidays = async () => {
  //       try {
  //         const response = await fetch(
  //           // `${API_BASE_URL}rcservice/getholidays?superid=${storedUserData.SuperId}`
  //         );
  //         const data = await response.json();
  //         if (data?.["Status"]) {
  //           const presentDate = new Date();
  //           const totalHolidaysData = data?.["ResultData"] || [];
  //           const futureHolidays = totalHolidaysData.filter((holiday) => {
  //             const holidayDate = new Date(holiday?.HolidayDt);
  //             return holidayDate > presentDate;
  //           });

  //           futureHolidays.sort(
  //             (a, b) => new Date(b?.HolidayDt) - new Date(a?.HolidayDt)
  //           );

  //           const lastFourHolidays = futureHolidays.slice(-4);
  //           setHolidays(lastFourHolidays);
  //         } else {
  //           setHolidays([]);
  //           console.error("Failed to fetch holidays:", response.statusText);
  //         }
  //       } catch (error) {
  //         setHolidays([]);
  //         console.error("Error fetching holidays:", error.message);
  //       }
  //     };
  //     fetchTeamLeaves();
  //     fetchHolidays();
  //   }
  // }, [storedUserData?.RegId]);

  useEffect(() => {
    const getCurrentDate = () => {
      const currentDate = new Date();
      const currentDateString = currentDate.toDateString();
      setSelectedCurentDate(currentDate.getDate());
      return {
        day: currentDateString.slice(0, 3),
        date: currentDate.getDate(),
        fullDate: currentDate,
      };
    };

    const getLastSixDays = () => {
      const currentDate = new Date();
      return Array.from({ length: 11 }, (_, index) => {
        const previousDate = new Date();
        previousDate.setDate(currentDate.getDate() - index - 1);
        return {
          day: previousDate.toDateString().slice(0, 3),
          date: previousDate.getDate(),
          fullDate: previousDate,
        };
      });
    };

    const lastSixDays = getLastSixDays();
    const currentDate = getCurrentDate();
    setDates([currentDate, ...lastSixDays]);
  }, []);

  const safeReplace = (str) => (str ? str.replace(/-/g, " ") : "");

  useEffect(() => {
    const fetch7DaysData = async () => {
      if (storedUserData?.SuperId && storedUserData?.RegId) {
        try {
          const today = new Date();
          const toDate = today.toISOString().split("T")[0];

          const last7 = new Date();
          last7.setDate(last7.getDate() - 11);
          const fromDate = last7.toISOString().split("T")[0];

          const response = await fetch(
            `${API_BASE_URL}Attendance/getempattendance?regid=${storedUserData.RegId}&superid=${storedUserData.SuperId}&fromdate=${fromDate}&todate=${toDate}`,
            {
              method: "GET",
              headers: { Authorization: `Bearer ${storedUserData?.Token}` },
            }
          );

          const data = await response.json();
          const attendanceDataArray = Array.isArray(data.ResultData)
            ? data.ResultData
            : [];

          setAttendanceData(attendanceDataArray);
        } catch (error) {
          console.error("Error fetching attendance data:", error);
        }
      }
    };

    fetch7DaysData();
  }, [storedUserData?.SuperId, storedUserData?.RegId]);

  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const [day, month, year] = formattedDate.split("/");
    const desiredFormatDate = `${year}-${month}-${day}`;

    setSelectedDate(desiredFormatDate);
    setSelectedActiveDate(day);

    const filteredData = attendanceData.filter((item) => {
      return item.Date === formattedDate;
    });
    setFilterData(filteredData);
  }, [attendanceData]);

  const handleDateSelect = (selectedDate) => {
    const formattedDate = selectedDate.fullDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const [day, month, year] = formattedDate.split("/");
    const desiredFormatDate = `${year}-${month}-${day}`;

    setSelectedDate(desiredFormatDate);
    setSelectedActiveDate(day);

    const filteredData = attendanceData.filter((item) => {
      return item.Date === formattedDate;
    });

    setFilterData(filteredData);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  // const colors = [
  //   "#20c997",
  //   "#6610f2",
  //   "#6f42c1",
  //   "#000000",
  //   "#ffc107",
  //   "#fd7e14",
  // ];
  const colors = [
    "primary",
    "secondary",
    "warning",
    "info",
    "danger",
    "success",
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatTime = (timeString) => {
    const date = new Date(`1970-01-01T${timeString}`);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const formatHolidayDate = (dateStr) => {
    const date = new Date(dateStr);

    // Extract individual parts using options
    const weekday = new Intl.DateTimeFormat("en-US", {
      weekday: "long",
    }).format(date);
    const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
      date
    );
    const day = new Intl.DateTimeFormat("en-US", { day: "numeric" }).format(
      date
    );

    // Wrap in a container to prevent commas
    return (
      <div>
        <div className="fw-bold small">{month.toUpperCase()}</div>
        <div className="fw-bold display-6">{day}</div>
        <div className="small">{weekday}</div>
      </div>
    );
  };

  const getBadgeClass = (status) => {
    switch (status) {
      case "P":
        return "badge-light-success";
      case "L":
        return "badge-light-warning";
      case "A":
        return "badge-light-danger";
      case "Missed Swipe":
        return "badge-light-info";
      case "No Swipe":
        return "badge-light-dark";
      default:
        return "badge-light-primary";
    }
  };

  const formatTimeHHMM = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (isNaN(date)) return "-";

    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  return (
    <div
      className="app-container container-xxl"
      style={{ marginBottom: "50px" }}
    >
      <div className="col-lg-12 col-xl-12 col-xxl-6 mb-5 mb-xl-0">
        <div className="card h-md-100 rounded">
          {/* <div
            className="card-header border-0 "
            style={{ backgroundColor: "#37A383" }}
          > */}
          <h3
            className="card-title rounded-top  p-2 justify-content-start d-flex"
            style={{ backgroundColor: "#D4F5E9" }}
          >
            <span className="card-label fw-bold text-dark">
              Your Attendance
            </span>
          </h3>
          {/* </div> */}
          <div className="card-body pt-7 px-0">
            <ul className="nav nav-stretch nav-pills nav-pills-custom nav-pills-active-custom d-flex flex-wrap justify-content-between mb-8 px-3">
              {dates
                .slice()
                .reverse()
                .map((dayDate, index) => (
                  <li key={index} className="nav-item p-0 ms-0 mb-2">
                    <a
                      className={`nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px py-3 px-2 btn-active-danger ${
                        dayDate.date === selectedActiveDate ? "active" : ""
                      } ${
                        dayDate.date === selectedCurentDate
                          ? "border btn-danger border-3"
                          : ""
                      }`}
                      data-bs-toggle="tab"
                      onClick={() => handleDateSelect(dayDate)}
                    >
                      <span className="fs-7 fw-semibold">{dayDate.day}</span>
                      <span className="fs-6 fw-bold">{dayDate.date}</span>
                    </a>
                  </li>
                ))}
            </ul>

            {filterData.length > 0 ? (
              <div className="d-flex flex-column">
                {filterData.map((attendance, index) => (
                  <div key={index} className="d-flex row m-0">
                    <div className="text-gray-800 fw-semibold fs-4 row mb-3 mx-2">
                      <div className="col-12 row">
                        <span
                          className={`col-auto badge ${getBadgeClass(
                            attendance.Status || "N/A"
                          )}`}
                        >
                          {attendance.Status || "N/A"}
                        </span>
                      </div>
                    </div>
                    <div className="text-gray-800 fw-semibold fs-4 row m-0 px-4 justify-content-between">
                      <div className="col-6 row">
                        <p className="col-3 text-start p-0">In</p>
                        <p className="col-2 text-center p-0">:</p>
                        <p className="text-success col-6 d-flex justify-content-start pe-0">
                          {attendance.InTime
                            ? formatTimeHHMM(attendance.InTime)
                            : "NA"}
                        </p>
                      </div>
                      <div className="col-6 row">
                        <p className="col-5 text-start p-0"> Out:</p>
                        <p className="col-1 text-center p-0">:</p>

                        <p className="text-success col-6 d-flex justify-content-start pe-0">
                          {attendance.OutTime
                            ? formatTimeHHMM(attendance.OutTime)
                            : "NA"}
                        </p>
                      </div>
                    </div>

                    <div className="text-gray-800 fw-semibold fs-4 row m-0 px-4 justify-content-between">
                      <div className="col-6 row">
                        <div className="col-3 text-start p-0"> Shift</div>
                        <p className="col-2 text-center p-0">:</p>
                        <p className="text-success col-6 d-flex justify-content-start pe-0">
                          {attendance.ActualShift
                            ? attendance.ActualShift
                            : "NA"}
                        </p>
                      </div>
                      <div className="col-6 row">
                        <p className="col-5 text-start p-0"> Duration</p>
                        <p className="col-1 text-center p-0">:</p>
                        <p className="text-success col-6 d-flex justify-content-start pe-0">
                          {attendance.Duration ? attendance.Duration : "NA"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <span className="badge bg-primary">No Swipes Available </span>
            )}
          </div>
        </div>

        <br />
        <div className="row gy-5 g-xl-10">
          <div className="col-xl-4 col-lg-6">
            {/* <div className="card card-flush h-xl-100">
              <div className="card-header pt-7">
                <h3 className="card-title align-items-start flex-column">
                  <span className="card-label fw-bold text-dark">
                    Upcoming Holidays
                  </span>
                </h3>
              </div>
              <div className="card-body">
                <div
                  className="hover-scroll-overlay-y pe-6 me-n6"
                  style={{ height: "320px" }}
                >
                  <div className="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
                    {Array.isArray(holidays) && holidays.length > 0 ? (
                      holidays.map((item, index) => (
                        <div
                          className="card d-flex flex-row align-items-center p-2 mb-2 border"
                          key={index}
                        >
                          <div
                            className={`text-center bg-${
                              colors[index % colors.length]
                            } text-white p-2 rounded`}
                            style={{ width: "6rem" }}
                          >
                            {formatHolidayDate(item.HolidayDt)}
                          </div>
                          <div className="ms-3">
                            <h6 className="fw-bold mb-0">
                              {item?.Reason
                                ? item.Reason
                                : "No Reason Available"}
                            </h6>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="d-flex justify-content-center">
                        <span className="text-gray-400 fw-bold">
                          No holidays found.
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {/* <div className="col-xl-8 col-lg-6" style={{ height: "445px" }}>
            <div className="card card-flush h-xl-100">
              <div className="card-header pt-7">
                <h3 className="card-title align-items-start flex-column">
                  <span className="card-label fw-bold text-dark">
                    Team Pending Leaves
                  </span>
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table align-middle table-row-dashed fs-6 gy-3">
                    <thead className="text-start">
                      <tr className=" text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                        <th className="min-w-100px">S.No</th>
                        <th className="min-w-125px">Name</th>
                        <th className="min-w-125px">Date</th>
                        <th className="min-w-125px">Leave Type</th>
                      </tr>
                    </thead>
                    <tbody className="fw-bold text-gray-600 text-start">
                      {currentItems.length > 0 ? (
                        currentItems.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{safeReplace(item.UserName)}</td>
                            <td>{safeReplace(formatDate(item.StartDt))}</td>
                            <td>{safeReplace(item.LvType)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr className="text-center fw-semibold">
                          <td colSpan={12}>No Leaves in pending.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  itemsPerPage={itemsPerPage}
                  totalItems={teamLeaves.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
